"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var idlUtils = require("../generated/utils.js");

exports.implementation =
/*#__PURE__*/
function () {
  function StyleSheetList() {
    _classCallCheck(this, StyleSheetList);

    this._list = [];
  }

  _createClass(StyleSheetList, [{
    key: "item",
    value: function item(index) {
      var result = this._list[index];
      return result !== undefined ? result : null;
    }
  }, {
    key: "_add",
    value: function _add(sheet) {
      var _list = this._list;

      if (!_list.includes(sheet)) {
        _list.push(sheet);
      }
    }
  }, {
    key: "_remove",
    value: function _remove(sheet) {
      var _list = this._list;

      var index = _list.indexOf(sheet);

      if (index >= 0) {
        _list.splice(index, 1);
      }
    }
  }, {
    key: "length",
    get: function get() {
      return this._list.length;
    }
  }, {
    key: idlUtils.supportedPropertyIndices,
    get: function get() {
      return this._list.keys();
    }
  }]);

  return StyleSheetList;
}();